export enum bossCrmPaths {
  COMMON = '',
  CALLS = '/calls',
  TASKS = '/tasks',
  EMPLOYEES = '/employees',
  LEADS = '/leads',
  CONVERSION = '/conversion',
  PLAN_FACT = '/plan-fact'
}
